import { cn } from "@/utils";
import { canvasToolbarDividerVariants } from "./canvasToolbarStyles";

interface CanvasToolbarDividerProps {
  className?: string;
}

export function CanvasToolbarDivider({ className }: CanvasToolbarDividerProps) {
  return (
    <div
      className={cn(canvasToolbarDividerVariants(), className)}
      aria-hidden="true"
    />
  );
}
